// import {Toast} from 'vant';
import { buildHttpClient } from "./Http";

class RouterIntercept {
    intercept;

    constructor(intercept) {
        this.intercept = intercept
    }
}

class AuthCheckIntercept extends RouterIntercept {
    https = {};

    constructor() {
        // eslint-disable-next-line no-unused-vars
        super((to, from, next) => {
            let http = buildHttpClient();
            console.log('-login-', http.isLogin())
            if (to.path != '/login') {
                if (!http.isLogin()) {
                    next('/login')
                    console.log('islogin')
                    return true
                }
                return false
            } else {
                http.removeToken();
            }
        })
    }
}



// eslint-disable-next-line no-unused-vars
export const authCheckIntercept = (new AuthCheckIntercept()).intercept;

